module.exports = __webpack_public_path__ + "img/comochegar02.2f9748a2.jpg";